// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `td{padding-right:32px;padding-top:4px}div.pending-oar-container{margin-top:32px}div.organization-container{display:table-header-group}button.cancel-oar{padding-left:32px;padding-right:32px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
